import { CLARITY_ID } from '../config/launch';

const SOURCE_KEY = 'sidwell_source';

// Where a visitor came from: share links like https://sidwell.ai/?ref=cfo-anna and every
// demo request (and Clarity recording) from that visit is tagged "cfo-anna".
function captureSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const source = params.get('ref') || params.get('utm_source');
    if (source) window.sessionStorage.setItem(SOURCE_KEY, source.slice(0, 80));
  } catch (err) {
    // Storage can be blocked (private mode, strict cookie settings) — tagging is best-effort.
  }
}

export function getSource() {
  try {
    return window.sessionStorage.getItem(SOURCE_KEY) || '';
  } catch (err) {
    return '';
  }
}

function loadClarity(id) {
  window.clarity =
    window.clarity ||
    function clarity(...args) {
      (window.clarity.q = window.clarity.q || []).push(args);
    };
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(id)}`;
  document.head.appendChild(script);
}

export function initAnalytics() {
  // The prerender build step mustn't count as a visit, or save the Clarity tag into the static HTML.
  if (window.__PRERENDER__) return;
  captureSource();
  if (!CLARITY_ID) return;
  loadClarity(CLARITY_ID);
  const source = getSource();
  if (source) window.clarity('set', 'source', source);
}

// Named events show up as filters in Clarity (e.g. only watch sessions that requested a demo).
export function trackEvent(name) {
  if (typeof window.clarity === 'function') window.clarity('event', name);
}
